// Qui a le droit de publier le programme (WHIP vers webrtc_<uuid>) — et que faire quand la main change.
//
// LE DÉFAUT. `webrtc_<uuid>` n'a qu'UN publieur : quand un second arrive, MediaMTX écrit
// « closing existing publisher » et éjecte le premier. Deux régies ouvertes sur la même
// chaîne se sont donc disputé le chemin : le 24/10/2026, 60 prises de publication en 14
// minutes (une toutes les 15 à 20 s, 01:30→01:44), le 23/10 57 éjections en deux heures. À
// chaque éjection, le pull RTSP de ffmpeg_regie tombait (« Feed interrompu »), puis
// ffmpeg_final se bloquait et était redémarré de force : l'antenne perdait sa source.
//
// Seul le DÉMARRAGE automatique était réservé à la régie qui a la main. Rien n'arrêtait la
// publication de celle qui la perdait (elle gardait sa PeerConnection ouverte, et tout
// chemin de reconnexion pouvait la rouvrir). Ces deux règles ferment les deux trous ; elles
// sont ici, hors du composant, pour être testées sans monter la régie.

/** Une régie ne publie le programme que si elle pilote la chaîne. */
export function canPublishProgram(isHolder: boolean): boolean {
  return isHolder;
}

/**
 * Que faire de la publication du programme quand l'état de la main change ?
 * 'stop' uniquement sur le front descendant (on avait la main, on ne l'a plus) ET si une
 * publication est en cours. Gagner la main ne déclenche rien ici : c'est l'effet de
 * publication permanente qui démarre, sur `isHolder`.
 */
export function programActionOnControlChange(
  wasHolder: boolean,
  isHolder: boolean,
  isPublishing: boolean,
): 'stop' | 'none' {
  return wasHolder && !isHolder && isPublishing ? 'stop' : 'none';
}
